import React, { useMemo } from "react";

import { SvgProps } from "../../utils/interfaces";
import { AccountsSvg } from "./set/AccountsSvg";
import { AccountSvg } from "./set/AccountSvg";
import { AddEnclosedSvg } from "./set/AddEnclosedSvg";
import { AddFilledSvg } from "./set/AddFilledSvg";
import { AddSvg } from "./set/AddSvg";
import { AppointmentsSvg } from "./set/AppointmentsSvg";
import { ArrowDownSvg } from "./set/ArrowDownSvg";
import { ArrowLeftFilledSvg } from "./set/ArrowLeftFilledSvg";
import { ArrowLeftSvg } from "./set/ArrowLeftSvg";
import { ArrowRightFilledSvg } from "./set/ArrowRightFilledSvg";
import { ArrowRightSvg } from "./set/ArrowRightSvg";
import { ArrowsInSimpleSvg } from "./set/ArrowsInSimpleSvg";
import { ArrowSquareOutSvg } from "./set/ArrowSquareOutSvg";
import { ArrowUpSvg } from "./set/ArrowUpSvg";
import { BankSvg } from "./set/BankSvg";
import { BillingSvg } from "./set/BillingSvg";
import { CallSvg } from "./set/CallSvg";
import { CarSvg } from "./set/CarSvg";
import { ChatsSvg } from "./set/ChatsSvg";
import { ChatSvg } from "./set/ChatSvg";
import { CheckboxCheckedSvg } from "./set/CheckboxCheckedSvg";
import { CheckboxUncheckedSvg } from "./set/CheckboxUncheckedSvg";
import { CheckEnclosedSvg } from "./set/CheckEnclosedSvg";
import { CheckFilledSvg } from "./set/CheckFilledSvg";
import { CheckSvg } from "./set/CheckSvg";
import { ChevronDownSvg } from "./set/ChevronDownSvg";
import { ChevronLeftFilledSvg } from "./set/ChevronLeftFilledSvg";
import { ChevronLeftSvg } from "./set/ChevronLeftSvg";
import { ChevronRightFilledSvg } from "./set/ChevronRightFilledSvg";
import { ChevronRightSvg } from "./set/ChevronRightSvg";
import { ChevronUpSvg } from "./set/ChevronUpSvg";
import { CircleGhostCrossSvg } from "./set/CircleGhostCrossSvg";
import { ClipboardSvg } from "./set/ClipboardSvg";
import { ClockCountdownSvg } from "./set/ClockCountdownSvg";
import { CloseEnclosedSvg } from "./set/CloseEnclosedSvg";
import { CloseFilledSvg } from "./set/CloseFilledSvg";
import { CloseSvg } from "./set/CloseSvg";
import { CloudSvg } from "./set/CloudSvg";
import { CoffeeSvg } from "./set/CoffeeSvg";
import { CopySvg } from "./set/CopySvg";
import { DesktopSvg } from "./set/DesktopSvg";
import { DishwasherSvg } from "./set/DishwasherSvg";
import { DownloadSvg } from "./set/DownloadSvg";
import { EmailSvg } from "./set/EmailSvg";
import { ErrorCircleSvg } from "./set/ErrorCircleSvg";
import { ErrorFilledSvg } from "./set/ErrorFilledSvg";
import { ErrorOutlineSvg } from "./set/ErrorOutlineSvg";
import { ErrorSvg } from "./set/ErrorSvg";
import { ExpandSvg } from "./set/ExpandSvg";
import { ExternalLinkSvg } from "./set/ExternalLinkSvg";
import { EyeHideIconSvg } from "./set/EyeHideIconSvg";
import { EyeShowIconSvg } from "./set/EyeShowIconSvg";
import { FileSvg } from "./set/FileSvg";
import { GridSvg } from "./set/GridSvg";
import { HardHatSvg } from "./set/HardHatSvg";
import { HelpSvg } from "./set/HelpSvg";
import { HomeSvg } from "./set/HomeSvg";
import { ImpactSvg } from "./set/ImpactSvg";
import { InfoCircleSvg } from "./set/InfoCircleSvg";
import { InfoFilledSvg } from "./set/InfoFilledSvg";
import { InfoOutlineSvg } from "./set/InfoOutlineSvg";
import { InProcessSvg } from "./set/InProcessSvg";
import { IssueErrorSvg } from "./set/IssueErrorSvg";
import { IssueTemporarySvg } from "./set/IssueTemporarySvg";
import { LightningSvg } from "./set/LightningSvg";
import { LoadingSvg } from "./set/LoadingSvg";
import { LockFilledSvg } from "./set/LockFilledSvg";
import { LockSvg } from "./set/LockSvg";
import { MarkerDotSvg } from "./set/MarkerDotSvg";
import { MarkerSvg } from "./set/MarkerSvg";
import { MenuSvg } from "./set/MenuSvg";
import { MilesSvg } from "./set/MilesSvg";
import { NotificationSvg } from "./set/NotificationSvg";
import { OnlineSvg } from "./set/OnlineSvg";
import { PasswordHideSvg } from "./set/PasswordHideSvg";
import { PasswordShowSvg } from "./set/PasswordShowSvg";
import { PaySvg } from "./set/PaySvg";
import { PenToolSvg } from "./set/PenToolSvg";
import { PerformanceSvg } from "./set/PerformanceSvg";
import { PinSvg } from "./set/PinSvg";
import { PlusSvg } from "./set/PlusSvg";
import { RadioCheckedSvg } from "./set/RadioCheckedSvg";
import { RadioUncheckedSvg } from "./set/RadioUncheckedSvg";
import { ReferralsSvg } from "./set/ReferralsSvg";
import { SaveSvg } from "./set/SaveSvg";
import { SearchSvg } from "./set/SearchSvg";
import { ShareSvg } from "./set/ShareSvg";
import { ShieldFilledSvg } from "./set/ShieldFilledSvg";
import { StopWatchIconSvg } from "./set/StopWatchIconSvg";
import { SIconSvg } from "./set/SIconSvg";
import { SubtractEnclosedSvg } from "./set/SubtractEnclosedSvg";
import { SubtractFilledSvg } from "./set/SubtractFilledSvg";
import { SubtractSvg } from "./set/SubtractSvg";
import { SuccessCircleSvg } from "./set/SuccessCircleSvg";
import { SuccessFilledSvg } from "./set/SuccessFilledSvg";
import { SuccessOutlineSvg } from "./set/SuccessOutlineSvg";
import { SunLineSvg } from "./set/SunLineSvg";
import { ToDoSvg } from "./set/ToDoSvg";
import { TrashSvg } from "./set/TrashSvg";
import { TrendingUpSvg } from "./set/TrendingUpSvg";
import { TvSvg } from "./set/TvSvg";
import { UserCheckSvg } from "./set/UserCheckSvg";
import { UserSvg } from "./set/UserSvg";
import { UsersSvg } from "./set/UsersSvg";
import { WarningCircleSvg } from "./set/WarningCircleSvg";
import { WarningFilledSvg } from "./set/WarningFilledSvg";
import { WarningOutlineSvg } from "./set/WarningOutlineSvg";
import { WarningSvg } from "./set/WarningSvg";
import { MaskSvg } from "./set/MaskSvg";
import { RunxSvg } from "./set/RunxSvg";
import { ShrinkSvg } from "./set/ShrinkSvg";

enum SvgNames {
  Accounts = "accounts",
  Account = "account",
  AddEnclosed = "add-enclosed",
  AddFilled = "add-filled",
  Add = "add",
  Appointments = "appointments",
  ArrowDown = "arrow-down",
  ArrowLeftFilled = "arrow-left-filled",
  ArrowLeft = "arrow-left",
  ArrowRightFilled = "arrow-right-filled",
  ArrowRight = "arrow-right",
  ArrowsInSimple = "arrows-in-simple",
  ArrowSquareOutSvg = "arrow-square-out",
  ArrowUp = "arrow-up",
  Bank = "bank",
  Billing = "billing",
  Call = "call",
  Car = "car",
  Chats = "chats",
  Chat = "chat",
  CheckboxChecked = "checkbox-checked",
  CheckboxUnchecked = "checkbox-unchecked",
  CheckEnclosed = "check-enclosed",
  CheckFilled = "check-filled",
  Check = "check",
  ChevronDown = "chevron-down",
  ChevronLeftFilled = "chevron-left-filled",
  ChevronLeft = "chevron-left",
  ChevronRightFilled = "chevron-right-filled",
  ChevronRight = "chevron-right",
  ChevronUp = "chevron-up",
  CircleGhostCross = "circle-ghost-cross",
  Clipboard = "clipboard",
  ClockCountdown = "clock-countdown",
  CloseEnclosed = "close-enclosed",
  CloseFilled = "close-filled",
  Close = "close",
  Cloud = "cloud",
  Coffee = "coffee",
  Copy = "copy",
  Desktop = "desktop",
  Dishwasher = "dishwasher",
  Download = "download",
  Email = "email",
  ErrorCircle = "error-circle",
  ErrorFilled = "error-filled",
  ErrorOutline = "error-outline",
  Error = "error",
  Expand = "expand",
  ExternalLink = "external-link",
  EyeHide = "eye-hide",
  EyeShow = "eye-show",
  File = "file",
  Grid = "grid",
  HardHat = "hard-hat",
  Help = "help",
  Home = "home",
  Impact = "impact",
  InfoCircle = "info-circle",
  InfoFilled = "info-filled",
  InfoOutline = "info-outline",
  InProcess = "in-Process",
  IssueError = "issue-error",
  IssueTemporary = "issue-temporary",
  Lightning = "lightning",
  Loading = "loading",
  LockFilled = "lock-filled",
  Lock = "lock",
  MarkerDot = "marker-dot",
  Marker = "marker",
  Mask = "mask",
  Menu = "menu",
  Miles = "miles",
  Notification = "notification",
  Online = "online",
  PasswordHide = "password-hide",
  PasswordShow = "password-show",
  Pay = "pay",
  PenToolSvg = "pen-tool",
  Performance = "performance",
  Pin = "pin",
  Plus = "plus",
  RadioChecked = "radio-checked",
  RadioUnchecked = "radio-unchecked",
  Referrals = "referrals",
  Runx = "runx",
  Save = "save",
  Search = "search",
  Share = "share",
  ShieldFilled = "shield-filled",
  Shrink = "shrink",
  StopWatchIconSvg = "stop-watch",
  SIconSvg = "s",
  StrokeHorizontal = "stroke-horizontal",
  StrokeVertical = "stroke-vertical",
  SubtractEnclosed = "subtract-enclosed",
  SubtractFilled = "subtract-filled",
  Subtract = "subtract",
  SuccessCircle = "success-circle",
  SuccessFilled = "success-filled",
  SuccessOutline = "success-outline",
  SunLine = "sun-line",
  SunrunIcon = "sunrun-icon",
  ToDo = "ToDo",
  Trash = "trash",
  TrendingUpSvg = "trending-up",
  Tv = "tv",
  UserCheckSvg = "user-check",
  UserSvg = "user",
  UsersSvg = "users",
  WarningCircle = "warning-circle",
  WarningFilled = "warning-filled",
  WarningOutline = "warning-outline",
  Warning = "warning",
}

const svgNameToComponentMap = {
  accounts: AccountsSvg,
  account: AccountSvg,
  "add-enclosed": AddEnclosedSvg,
  "add-filled": AddFilledSvg,
  add: AddSvg,
  appointments: AppointmentsSvg,
  "arrow-down": ArrowDownSvg,
  "arrow-left-filled": ArrowLeftFilledSvg,
  "arrow-left": ArrowLeftSvg,
  "arrow-right-filled": ArrowRightFilledSvg,
  "arrow-right": ArrowRightSvg,
  "arrows-in-simple": ArrowsInSimpleSvg,
  "arrow-square-out": ArrowSquareOutSvg,
  "arrow-up": ArrowUpSvg,
  bank: BankSvg,
  billing: BillingSvg,
  call: CallSvg,
  car: CarSvg,
  chats: ChatsSvg,
  chat: ChatSvg,
  "checkbox-checked": CheckboxCheckedSvg,
  "checkbox-unchecked": CheckboxUncheckedSvg,
  "check-enclosed": CheckEnclosedSvg,
  "check-filled": CheckFilledSvg,
  check: CheckSvg,
  "chevron-down": ChevronDownSvg,
  "chevron-left-filled": ChevronLeftFilledSvg,
  "chevron-left": ChevronLeftSvg,
  "chevron-right-filled": ChevronRightFilledSvg,
  "chevron-right": ChevronRightSvg,
  "chevron-up": ChevronUpSvg,
  "circle-ghost-cross": CircleGhostCrossSvg,
  clipboard: ClipboardSvg,
  "clock-countdown": ClockCountdownSvg,
  "close-enclosed": CloseEnclosedSvg,
  "close-filled": CloseFilledSvg,
  close: CloseSvg,
  cloud: CloudSvg,
  coffee: CoffeeSvg,
  copy: CopySvg,
  desktop: DesktopSvg,
  dishwasher: DishwasherSvg,
  download: DownloadSvg,
  email: EmailSvg,
  "error-circle": ErrorCircleSvg,
  "error-filled": ErrorFilledSvg,
  "error-outline": ErrorOutlineSvg,
  error: ErrorSvg,
  expand: ExpandSvg,
  "external-link": ExternalLinkSvg,
  "eye-hide": EyeHideIconSvg,
  "eye-show": EyeShowIconSvg,
  file: FileSvg,
  grid: GridSvg,
  "hard-hat": HardHatSvg,
  help: HelpSvg,
  home: HomeSvg,
  impact: ImpactSvg,
  "info-circle": InfoCircleSvg,
  "info-filled": InfoFilledSvg,
  "info-outline": InfoOutlineSvg,
  "in-Process": InProcessSvg,
  "issue-error": IssueErrorSvg,
  "issue-temporary": IssueTemporarySvg,
  lightning: LightningSvg,
  loading: LoadingSvg,
  "lock-filled": LockFilledSvg,
  lock: LockSvg,
  "marker-dot": MarkerDotSvg,
  marker: MarkerSvg,
  mask: MaskSvg,
  menu: MenuSvg,
  miles: MilesSvg,
  notification: NotificationSvg,
  online: OnlineSvg,
  "password-hide": PasswordHideSvg,
  "password-show": PasswordShowSvg,
  pay: PaySvg,
  "pen-tool": PenToolSvg,
  performance: PerformanceSvg,
  pin: PinSvg,
  plus: PlusSvg,
  "radio-checked": RadioCheckedSvg,
  "radio-unchecked": RadioUncheckedSvg,
  referrals: ReferralsSvg,
  runx: RunxSvg,
  save: SaveSvg,
  search: SearchSvg,
  share: ShareSvg,
  "shield-filled": ShieldFilledSvg,
  shrink: ShrinkSvg,
  "stop-watch": StopWatchIconSvg,
  s: SIconSvg,
  "subtract-enclosed": SubtractEnclosedSvg,
  "subtract-filled": SubtractFilledSvg,
  subtract: SubtractSvg,
  "success-circle": SuccessCircleSvg,
  "success-filled": SuccessFilledSvg,
  "success-outline": SuccessOutlineSvg,
  "sun-line": SunLineSvg,
  ToDo: ToDoSvg,
  trash: TrashSvg,
  "trending-up": TrendingUpSvg,
  tv: TvSvg,
  "user-check": UserCheckSvg,
  user: UserSvg,
  users: UsersSvg,
  "warning-circle": WarningCircleSvg,
  "warning-filled": WarningFilledSvg,
  "warning-outline": WarningOutlineSvg,
  warning: WarningSvg,
};

const isSvgName = (tbd: any): tbd is SvgNames =>
  Object.keys(svgNameToComponentMap).includes(tbd);

type SvgIconProps = {
  name: SvgNames;
  height?: SvgProps["height"];
  viewBox?: SvgProps["viewBox"];
  width?: SvgProps["width"];
  color?: SvgProps["color"];
  style?: SvgProps["style"];
};
const SvgIcon: React.FC<SvgIconProps> = ({
  name,
  height,
  viewBox,
  width,
  color,
  style,
  ...rest
}) => {
  const Component: React.FC<SvgProps> = useMemo(() => {
    return svgNameToComponentMap[name] ?? RunxSvg;
  }, [name]);

  return (
    <Component
      height={height}
      width={width}
      viewBox={viewBox}
      color={color}
      style={style}
      {...rest}
    />
  );
};

export { SvgIcon, SvgNames, isSvgName, svgNameToComponentMap };
export type { SvgIconProps };
